var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"water-mark",style:('width:' + _vm.width + ';'),attrs:{"absolute":true}},[_vm._v("© "+_vm._s(_vm.content))])}
var staticRenderFns = []

export { render, staticRenderFns }